import { getStyledElement } from "@/helpers";
import { IonSpinner } from "@ionic/react";

export const Spinner = getStyledElement(IonSpinner)();
